import React, { forwardRef } from "react";
import { InputMask } from "primereact/inputmask";

const GenericHour = forwardRef((props, ref) => {
  return <InputMask mask="99:99:99" slotChar="24:59:00" {...props} ref={ref} />;
});

export default GenericHour;
